import { Step } from "./stepHelper";

export function isAuthToApproval(procurement) {
    switch (procurement.step.name) {
        case Step.WRITING_SPECIFICATIONS:
        case Step.APPROVAL_SPECIFICATIONS_BY_MANAGER:
        case Step.BUDGET_LEGAL_CHECK:
        case Step.APPROVAL_SPECIFICATIONS:
        case Step.APPROVAL_SPECIFICATIONS_BY_BOD:
        case Step.VALIDATION_ENCODING_E_PROCUREMENT:
        case Step.VALIDATION_OFFER_REQUEST_EMAIL:
        case Step.WRITING_ATTRIBUTION:
        case Step.APPROVAL_ATTRIBUTION:
        case Step.APPROVAL_ATTRIBUTION_BY_BOD:
        case Step.VALIDATION_ATTRIBUTION:
        case Step.WRITING_ORDER:
        case Step.VALIDATION_ORDER:
            return procurement.isUserAction;
        default:
            return false;
    }
}

export function isAuthToRequest(procurement) {
    switch (procurement.step.name) {
        case Step.APPROVAL_SPECIFICATIONS_BY_MANAGER:
        case Step.BUDGET_LEGAL_CHECK:
        case Step.APPROVAL_SPECIFICATIONS:
        case Step.APPROVAL_SPECIFICATIONS_BY_BOD:
        case Step.APPROVAL_ATTRIBUTION:
        case Step.APPROVAL_ATTRIBUTION_BY_BOD:
            return procurement.isUserAction;
        default:
            return false;
    }
}
